
import './index.less'
import React from 'react'
console.log(React)
export default function ImageBox(props) {
  return (<div className={`imageBox ${props.isActive ? 'active' : ''}`}>
    {props.src ? <div className='iamgeBox_img'>
      <img className='img' src={props.src} onClick={() => {
        props.imgClick && props.imgClick()
      }} />
      <i className='icon' onClick={() => {
        props.mySwitch && props.mySwitch()
      }}>
        <svg width='12' height='12' viewBox='0 0 18 18' fill='#fff' ><path d='M3.5 3.5V6.5H6.5V3.5H3.5ZM16 10V16H10V10H16ZM3.5 9V10.5C3.5 11.7426 4.50736 12.75 5.75 12.75H7V11L9.75 13.5L7 16V14.25H5.75C3.67893 14.25 2 12.5711 2 10.5V9H3.5ZM14.5 11.5H11.5V14.5H14.5V11.5ZM11 2V3.75H12.25C14.3211 3.75 16 5.42893 16 7.5V9H14.5V7.5C14.5 6.25736 13.4926 5.25 12.25 5.25H11V7L8.25 4.5L11 2ZM8 2V8H2V2H8Z' fill-rule='evenodd'></path></svg>
      </i>
    </div> : <div className='imageBox_div' onClick={() => {
      props.change && props.change()
    }}>

    </div>}

  </div>)
}
